import { StandardProps } from "../componentMap";
import { FitFinder } from "../FitFinder/FitFinder";
import { SizeChart } from "../SizeChart/SizeChart";
import styles from "./FitToolAndSizeChart.module.scss";

export const FitToolAndSizeChartUI = (
  props: Pick<StandardProps, "product" | "runtimeConfig">,
) => (
  <div
    className={styles.sizeAndFitWrapper}
    data-testid="fit-tool-and-size-chart"
    data-component="FitToolAndSizeChart"
  >
    <FitFinder {...props} />
    <div className={styles.sizeChartColumn}>
      <SizeChart {...props} />
    </div>
  </div>
);
